<template>
  <AttendancePage
    v-if="activeSubTab === 'attendance'"
    :api-base="apiBase"
    :skip-privilege-check="skipPrivilegeCheck"
    :privilege-name="attendancePrivilegeName"
    :monthly-privilege-name="monthlyPrivilegeName"
    :earn-privilege-name="earnPrivilegeName"
    :attendance-privilege-name="attendancePrivilegeName"
    @navigate="onNavigate"
  />
  <MonthlyConfigurationShell
    v-else
    active-tab="earn"
    :skip-privilege-check="skipPrivilegeCheck"
    :monthly-privilege-name="monthlyPrivilegeName"
    :earn-privilege-name="earnPrivilegeName"
    :attendance-privilege-name="attendancePrivilegeName"
    @navigate="onNavigate"
  >
    <MonthlyConfigurationFilters
      :filters-locked="filtersLocked"
      :api-base="apiBase"
    />
    <EarnAndDeductForm
      v-model:entries="localEntries"
      :api-base="apiBase"
      :skip-privilege-check="skipPrivilegeCheck"
      :privilege-name="earnPrivilegeName"
    />
  </MonthlyConfigurationShell>
</template>

<script setup>
import { defineProps, onMounted, ref } from 'vue'
import AttendancePage from './attendancePage.vue'
import MonthlyConfigurationShell from './monthlyConfigurationShell.vue'
import MonthlyConfigurationFilters from './monthlyConfigurationFilters.vue'
import EarnAndDeductForm from './earnAndDeductForm.vue'
import { useEarnDeductLocalStorage } from './useEarnDeductLocalStorage.js'
import { resetMonthlyConfigurationForm } from './useMonthlyConfigurationFilters.js'

defineProps({
  apiBase: {
    type: String,
    default: '/finance'
  },
  skipPrivilegeCheck: {
    type: Boolean,
    default: false
  },
  monthlyPrivilegeName: {
    type: String,
    default: 'Monthly Configuration'
  },
  earnPrivilegeName: {
    type: String,
    default: 'Earn And Deduct'
  },
  attendancePrivilegeName: {
    type: String,
    default: 'Attendance'
  }
})

const activeSubTab = ref('attendance')

const { localEntries, filtersLocked } = useEarnDeductLocalStorage()

onMounted(() => {
  // Prevent stale shared monthly-configuration filters from other pages.
  resetMonthlyConfigurationForm()
})

function onNavigate(tab) {
  if (tab === 'earn' || tab === 'attendance') {
    if (activeSubTab.value !== tab) {
      resetMonthlyConfigurationForm()
    }
    activeSubTab.value = tab
  }
}
</script>
